export default __webpack_public_path__ + "static/media/ic_notification_active.7a62dcea.svg";